<app-simple-header></app-simple-header>

<ion-content class="ion-padding ion-text-center">
  <ion-grid>
    <ion-row>
      <ion-col>
        <ion-icon size="large" color="warning" name="warning-outline"></ion-icon>
        <h1><b>Limpar dados da Conta</b></h1>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col>
        <div class="splash-info">
          <div class="splash-intro">
            Essa ação irá LIMPAR TODOS OS DADOS do seu usuário (históricos, ciclos, revisões etc), mas irá manter seu cadastro e seu login ativos, além de manter eventuais planos já pagos.
          </div>
        </div>
      </ion-col>
    </ion-row>
    <br />
    <ion-row>
      <ion-col>
          <ion-chip style="font-size: small;" color="warning">ATENÇÃO: <br/> isso não poderá ser desfeito!</ion-chip> 
      </ion-col>
    </ion-row>
    <br />

    <ion-row>
      <ion-col>
        <ion-item class="box">
          <ion-input [(ngModel)]="deleteFieldValue" autocapitalize="characters" type="text" placeholder="Digite LIMPAR DADOS"></ion-input>
        </ion-item>
     </ion-col>
    </ion-row>

    <br />
    <ion-row>
      <ion-col>
        <ion-button expand="block" color="warning" (click)="clickDelete()">
          Limpar Dados
        </ion-button>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col>
        <ion-button  expand="block" (click)="clickCancel()">
          Cancelar
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>